export default {
  googleAuthorizeTerms: "此应用在 2023 年 3 月 10 日后将不再受支持。请安装新版 {googleAppName}。"
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
